import React, {  Component } from 'react';
import { connect } from 'react-redux';
import { browserHistory } from 'react-router';
import moment from 'moment';
import _ from 'lodash';
import RequestReturnUploadImageDialog from '../../dialogs/requestReturnUploadImageDialog';
import RequestReturnWarningDialog from '../../dialogs/requestReturnWarningDialog';
import RequestReturnApprovalDialog from '../../dialogs/requestReturnApprovalDialog';
import RequestReturnFileWarningDialog from '../../dialogs/requestReturnFileWarningDialog';
import { customerClassCodeElements } from '../../common/LookUpTable';

/* Actions */
import {
	createNewOrder,
	setRequestReturnDetails,
	storeReturnUda,
} from '../../../redux/actions';

import { routes } from '../../../redux/api/routes';
let { s3BucketAPIBaseURL } = routes;

class RequestReturnStep3 extends Component {

	constructor(props) {
		super(props);
		this.state = {
			isOrderPlaced: false,
			requestReturnOrderId: '',
			selectAll: false,
			submitErrorMessage:false,
			isOOPChecked: false,
			approverName:'',
			returnTypeIndicator:'',
			isOOP:false,
			showOopErrorMessage: false,
			showSerialNumberuploadError: false,
			showRequestReturnUploadImageDialog: false,
			showRequestReturnWarningDialog:false,
			showRequestReturnApprovalDialog:false,
			showRequestReturnFileWarningDialog:false,
		};
		this.checkASMOrIsInDL = this.checkASMOrIsInDL.bind(this);
	}

	componentWillMount() {
		window.scrollTo(0, 0);
		// Redirect to request return page if there is no data in store, it means page is refreshed
		if(!this.props.order.requestReturnDetails) {
			browserHistory.push("/requestreturn");
		}else {
			this.setState({
				requestReturnDetails: this.props.order.requestReturnDetails
			});
		}
	}

	selectAllWaiveOff(event) {
		const checked = event.target.checked;
		const self = this;
		self.setState({
			selectAll: checked
		}, () => {
			let orderDetails = self.state.requestReturnDetails;
			orderDetails.responseObject.items.forEach((item, index) => {
				if(item.selected) {
					item.restockingFeeWaive = checked;
				}
			});
			self.setState({
				requestReturnDetails: orderDetails
			});
			// self.props.setRequestReturnDetails(orderDetails);
		});
	}

	handleSubmitStep3(job, lot, restockingPoNum, shippingMethod, customerClassCode,event) {
		event.preventDefault();
		const self = this;
		let { typeOfUser, isASM } = self.props.user.userDetails;
		if(typeOfUser === 'employee') {
			typeOfUser = isASM ? 'ASM' : 'Employee';
		} else if(typeOfUser === 'customer') {
			typeOfUser = 'Customer';
		}
		let payload = self.state.requestReturnDetails.responseObject;
		let warehouseCode = payload.warehouseCode;
		let derivedShippingMethod = 'SDS Delivery';
		if(payload.deliveryMethod === "I will return the products myself") {
			derivedShippingMethod = 'SDS Will Call';
		} else if(payload.shippingMethod === 'ADC Truckload' || payload.shippingMethod === 'ADC Velocity' || payload.shippingMethod === 'ADC LTL' ||
			payload.originalShippingAddress !== JSON.stringify(payload.shippingAddress)
		) {
			const zipCode = payload.shippingAddress && payload.shippingAddress.zip;
			const state = payload.shippingAddress && payload.shippingAddress.state;
			if(zipCode) {
				let sds_loc = '';
				let return_loc = '';

				self.props.getShippingAddressesDetails(zipCode.split('-')[0], false, "sds_loc", (resp) => {
					if(resp && resp.agentid) {
						sds_loc = resp.agentid;
					}
				}, true, state);
				self.props.getShippingAddressesDetails(zipCode.split('-')[0], false, "return_loc", (resp) => {
					if(resp && resp.agentid) {
						return_loc = resp.agentid;
					}
				}, true, state);
				if(sds_loc && return_loc && sds_loc === return_loc) {
					derivedShippingMethod = 'SDS Delivery';
					warehouseCode = sds_loc;
				} else {
					self.props.getShippingAddressesDetails(zipCode.split('-')[0], false, "adc_loc", (resp) => {
						if(resp && resp.agentid) {
							warehouseCode = resp.agentid;
						}
					}, true, state);
					derivedShippingMethod = 'ADC LTL';
				}
			}
		}
		const { accountResponsibilityData, selectedAccount } = self.props.user;
		payload = {
			...payload,
			warehouseCode,
			poNumber: payload.poNumber.trim(),
			job: job[0].value !== "" ? job[0].value:"",
			lot: lot[0].value !== "" ? lot[0].value:"",
			deliveryPhone: payload.deliveryPhone.replace("(", "").replace("-", "").replace(")", "").replace(" ", ""),
			originalShippingMethod: payload.shippingMethod,
			userType: typeOfUser,
			returnAuthPersonName : self.state.approverName,
			returnTypeIndicator: self.state.returnTypeIndicator,
			deliveryMethod: derivedShippingMethod,
			accountDescription: selectedAccount.ACCOUNTDESCRIPTION,
			returns: (!accountResponsibilityData || !accountResponsibilityData.responseObject || !accountResponsibilityData.responseObject.returns) ? 'ASMApprovalRequired' : accountResponsibilityData.responseObject.returns
		}
		payload.items = payload.items.filter(item => item.selected === true);
		// WCP-7555: When a user returns a service contract item, and they select Replacement=Y.
		// we should NOT send the service contract item in the payload as a replacement.
		// The service contract will be added to the product as a BAG.
		payload.items = payload.items.filter(item => {
			if(!item.replacementNeeded && item.item.indexOf('1-YR') === 0 || item.item.indexOf('2-YR') === 0 || item.item.indexOf('4-YR') === 0){
				item.lineType = "Return Line"
			}
			return (!item.replacementNeeded && (item.item.indexOf('1-YR') === 0 || item.item.indexOf('2-YR') === 0 || item.item.indexOf('4-YR') === 0)) || 
				   (item.replacementNeeded && !(item.item.indexOf('1-YR') === 0 || item.item.indexOf('2-YR') === 0 || item.item.indexOf('4-YR') === 0) || 
				   (!item.replacementNeeded && !(item.item.indexOf('1-YR') === 0 || item.item.indexOf('2-YR') === 0 || item.item.indexOf('4-YR') === 0)));
		});
		// if type of user is customer &&
		// 		if invoiceDate is null -> status: Save
		// 		if invoiceDate < 90 days -> status: Submit
		// if(typeOfUser === 'Customer') {
		// 	if(!payload.warehouseCode) {
		// 		payload = {
		// 			...payload,
		// 			status: 'Save'
		// 		}
		// 	} else {
		// 		if(!payload.invoiceDate) {
		// 			payload = {
		// 				...payload,
		// 				status: 'Save'
		// 			}
		// 		} else if(moment(payload.invoiceDate).isBefore(moment().subtract(90, 'day'))) {
		// 			payload = {
		// 				...payload,
		// 				status: 'Submit'
		// 			}
		// 		}
		// 	}
		// }
		let allfileUploaded = true;
		const serialcheckLIst = payload.items.filter(itm => itm.serialNumber !== '' && itm.serialNumber !== 'NA' && itm.selected);
		for(const item of serialcheckLIst) {
			let count = item.returnQuantity;
			if(item.fileUploadSerialErrors) {
				for (const [serial, errorMessage] of item.fileUploadSerialErrors.entries()) {
					if(errorMessage !== 'File is uploaded successfully.') {
						allfileUploaded = false;
						self.setState({
							showSerialNumberuploadError : true,
							showRequestReturnWarningDialog: true
						});
						break;
					} else {
						count--;
						self.setState({
							showSerialNumberuploadError : false,
							showRequestReturnWarningDialog: false
						});
					}
				} 
				if(count != 0){
					allfileUploaded = false;
						self.setState({
							showSerialNumberuploadError : true,
							showRequestReturnWarningDialog:true
						});
				}
				//
			} else if(item.returnReason.startsWith("Damaged")) {
				if((shippingMethod === 'SDS Delivery' || shippingMethod === "SDS Delivery Next Day" || shippingMethod ==='Meet Truck') && customerClassCodeElements.includes(customerClassCode)){
					self.setState({
						showSerialNumberuploadError : false,
					});
				}else{
					allfileUploaded = false;
					self.setState({
						showSerialNumberuploadError : true,
						showRequestReturnWarningDialog: true
					});	
				}
				break;
			}
		}

		payload.items.map(itm => {
			if(itm.replacementNeeded == true){
				itm.scheduleArrivalDate = moment(payload.requestedDeliveryDate).format()
			}
			if(!itm.serialNumber && itm.selected){
				itm.serialNumber = "NA"
			}
			if(itm.relatedServices && itm.relatedServices.length>0){
				itm.relatedServices.map(relItm=>{
					relItm.quantity = itm.returnQuantity
				})
			}
		})

		if(((self.state.isOOP && self.state.isOOPChecked && self.state.approverName !== '' && self.state.approverName.length >= 5 && allfileUploaded ) 
				|| (!self.state.isOOP && !self.state.isOOPChecked && allfileUploaded ))) {
			if (self.props.user.userDetails.isNonGEASsoUser && self.props.user.userDetails.isManRepSsoUser) {
				payload.salesRepNum = self.props.getASMAndDSASMSSOList();
			}
			self.props.createNewOrder(payload, "requestType=requestReturn", false, response => {
				if(response.status) {
					if(self.state.isOOP) {
						let udaData = {
							...response.responseObject,
							returnAuthPersonName : self.state.approverName,
							returnTypeIndicator: self.state.returnTypeIndicator,
						};
						self.props.storeReturnUda(udaData,false, resp => {
							if(resp.status) {
								self.setState({
									isOrderPlaced: true,
									orderPlacedDetails: response.responseObject,
									requestReturnOrderId: response.responseObject.orderNumber,
									showOopErrorMessage: false,
									showRequestReturnApprovalDialog: false
								});
								self.props.setRequestReturnDetails(null);
							}
						});
					} else {
						self.setState({
							isOrderPlaced: true,
							orderPlacedDetails: response.responseObject,
							requestReturnOrderId: response.responseObject.orderNumber,
							showOopErrorMessage: false,
							showRequestReturnApprovalDialog: false
						});
						self.props.setRequestReturnDetails(null);
					}
					
				} else {
					browserHistory.push("/error");
				}
			})
		} else if(allfileUploaded) {
			self.setState({
				showOopErrorMessage: true,
				showRequestReturnApprovalDialog: true
			})
		}

	}

	handleDialog(dialog, flag, event) {
		event && event.preventDefault();
		this.setState({
			['show'+dialog]: false
		}, () => {
			this.setState({
				['show'+dialog]: flag
			})
		})
	}

	checkASMOrIsInDL() {
		const self = this;
		const { userDetails } = self.props.user;
		let showRestockingCheckbox = false;
		if(userDetails) {
			showRestockingCheckbox = userDetails.isInDL || userDetails.isASM || userDetails.otherASM;
		}
		return showRestockingCheckbox;
	}

	onChangeUpdateItems(indx, event) {
		const self = this;
		let orderDetails = self.state.requestReturnDetails;
		orderDetails.responseObject.items.forEach((item, index) => {
			if(indx === index) {
				item[event.target.name] = event.target.type === 'checkbox'?event.target.checked:event.target.value;
				if(event.target.type === 'checkbox' && !event.target.checked) {
					self.setState({
						selectAll: false
					});
				}
			}
		});
		self.setState({
			requestReturnDetails: orderDetails
		});
		// self.props.setRequestReturnDetails(orderDetails);
	}

	handleCheckboxChange (event) {
		const self = this;
		const checked = event.target.checked;
		self.setState({
			isOOPChecked: checked
		});
	  }

	handleApproverName (event) {
		const self = this;
		const approverName = event.target.value;
			self.setState({
				approverName: approverName,
				returnTypeIndicator: 'OOP'
			});
	};

	handleFileChange = (item, serial, index) =>  (event) => {
		const self = this;
		const files = event.target.files;
		const requestReturnDetails = self.state.requestReturnDetails;
		if (!requestReturnDetails.responseObject.items[index].fileUploadSerialErrors){
			requestReturnDetails.responseObject.items[index].fileUploadSerialErrors = new Map();
			self.props.setRequestReturnDetails(requestReturnDetails);
		}
		if(!requestReturnDetails.responseObject.items[index].serialAndUplodedFileList) {
			requestReturnDetails.responseObject.items[index].serialAndUplodedFileList = new Map();
		}
		requestReturnDetails.responseObject.items[index].serialAndUplodedFileList.get(serial) ? '': requestReturnDetails.responseObject.items[index].serialAndUplodedFileList.set(serial, []);
		self.props.setRequestReturnDetails(requestReturnDetails);
		if(files.length > 0) {
			const allowedTypes = ['image/jpeg', 'image/pjpeg', 'image/gif', 'image/png', 'image/bmp', 'image/x-windows-bmp', 'application/pdf'];
  			const invalidFiles = Array.from(files).filter(file => !allowedTypes.includes(file.type));
			if (invalidFiles.length > 0) {
				requestReturnDetails.responseObject.items[index].fileUploadSerialErrors.set(serial, 'Invalid file type. Please select a JGP, PNG or PDF file.');
				this.setState({
					showRequestReturnFileWarningDialog :true
				})
				self.props.setRequestReturnDetails(requestReturnDetails);
				return;
			}

			for (let i = 0; i < files.length; i++) {
				if(files[i].size/1000 > 5000) {
					requestReturnDetails.responseObject.items[index].fileUploadSerialErrors.set(serial, "Please select a file that is not larger than 5 MB");
					self.props.setRequestReturnDetails(requestReturnDetails);
				} else {
					requestReturnDetails.responseObject.items[index].fileUploadSerialErrors.set(serial, '');
					self.props.setRequestReturnDetails(requestReturnDetails);
				}
			}
			if(requestReturnDetails.responseObject.items[index].fileUploadSerialErrors.get(serial) === '') {
				this.uploadFiles(files, item, serial, index);
			}
		}
	};

	uploadFiles = async (files, item, serial, index) => {
		const self = this;
		const { userDetails } = self.props.user;
		const orderDetails = self.state.requestReturnDetails && self.state.requestReturnDetails.responseObject;
		const requestReturnDetails = self.state.requestReturnDetails;

		// handle file upload
		const uploadFile = (file) => {
			const existingFileNames = requestReturnDetails.responseObject.items[index].serialAndUplodedFileList.get(serial);
			
			// Append the new file name to the array if it's not already there
			if (!existingFileNames.includes(file.name)) {
				existingFileNames.push(file.name);
			}

			const reader = new FileReader();

			reader.addEventListener('loadend', function (e) {
				fetch(s3BucketAPIBaseURL, {
					method: "POST",
					headers: {
						'Content-Type': 'application/json',
						"Authorization": `${userDetails.jwt}${userDetails.sso}`,
					},
					body: JSON.stringify({
						name:  `CustomerNet/ReturnAndCredit/Returns/${orderDetails.accountNumber}/${orderDetails.originalOrderNumber}/${orderDetails.originalOrderNumber}-${item.item}-${serial}-${moment()}`,
						type: file.type
					})
				}).then(function (response) {
					return response.json();
				}).then(function (json) {
					return fetch(json.uploadURL, {
						method: "PUT",
						body: new Blob([reader.result], {
							type: file.type
						})
					})
				}).then(function () {
					requestReturnDetails.responseObject.items[index].fileUploadSerialErrors.set(serial, 'File is uploaded successfully.');
					requestReturnDetails.responseObject.items[index].serialAndUplodedFileList.set(serial, existingFileNames);
					self.props.setRequestReturnDetails(requestReturnDetails);
					self.setState({
						showSerialNumberuploadError : false,
						showRequestReturnWarningDialog: false
					});
				});
			});
			
			reader.readAsArrayBuffer(file);
		};

		// Use Promise.all to wait for all uploads to complete
		await Promise.all(Array.from(files).map(uploadFile));
		
	}

	isAnyReplacementSelected(orderDetails) {
		let flag = false;
		orderDetails.items.forEach(itm => {
			if(itm.replacementNeeded) {
				flag = true;
			}
		});
		return flag;
	}

	componentDidMount() {
		const self = this;
		window.scrollTo(0, 0);
		const orderDetails = self.state.requestReturnDetails && self.state.requestReturnDetails.responseObject;
		const { invoiceDate } = self.state.requestReturnDetails && self.state.requestReturnDetails.responseObject;
		const relationShipTypes = self.props.user.relationShipPartyList.responseObject.filter(party => party.RELATIONSHIP_STATUS === 'A').map(item => item.RELATIONSHIP_TYPE);
		const invoice = self.props.user.allTcaList.responseObject.filter(item => relationShipTypes.includes(item.tcaRelationshipName));
		const defaultInvoice = self.props.user.allTcaList.responseObject.filter(item => item.tcaRelationshipName === 'Default');
		const invoiceAge = invoice.length > 0 ? invoice[0].invoiceAge : defaultInvoice[0].invoiceAge;
		if(orderDetails.items){
			for (const item of orderDetails.items) {
				if(item.selected && moment(item.invoiceDate).isBefore(moment().subtract(invoiceAge, 'days'), 'day')) {
					self.setState({
						isOOP: true
					});
					break;
				}
			}
		}
	}

    render() {
		const self = this;
		const orderDetails = self.state.requestReturnDetails && self.state.requestReturnDetails.responseObject;
		const orderHeaderAttribute = self.props.order.requestReturnList && self.props.order.requestReturnList.responseObject[0];
		const shippingAddress = orderDetails && orderDetails.shippingAddress;
		const returnToAddress = orderDetails && orderDetails.returnToAddress;
		const { isOrderPlaced, orderPlacedDetails } = self.state;
		const { userDetails } = self.props.user;
		const deliveryMethod = orderDetails && orderDetails.deliveryMethod;
		const shippingMethod = orderDetails && orderDetails.shippingMethod;
		const job = orderHeaderAttribute.orderHeader.attributes.attribute.filter((itm)=>itm.name === "Attribute19");
		const lot =orderHeaderAttribute.orderHeader.attributes.attribute.filter((itm)=>itm.name === "Attribute20");
		const { selectedAccount } = self.props.user,
		customerClassCode = selectedAccount && selectedAccount.CUSTOMERCLASSCODE ? selectedAccount.CUSTOMERCLASSCODE : "";
        return (
			<div>
				{isOrderPlaced
					?<div className="push  d-none d-sm-block">
						<p className="textRight">
							<a className="withIcon withPrintIcon noUnderline bold uppercase" onClick={this.props.handlePrint} href="">Print Return Request Confirmation</a>
						</p>
						<h1 className="pageTitle">Return Request Confirmation</h1>
						{userDetails.typeOfUser === 'customer'
							?<div>
								<p className="orange"><b>Your return request has been submitted and is pending approval. You will be notified of the status of your request.<br />Any notes you may have included have been captured.</b></p>
								<p className="orange">
									<b>
										{deliveryMethod === "I will return the products myself"
											? "If your request is approved, please print out the Return Authorization received via email and return the product to warehouse."
											: "If your request is approved, you will be contacted by the SDS within 3-5 days to schedule pickup of the item(s) shown."
										}
									</b>
								</p>
							</div>
							:<div>
								{(userDetails.typeOfUser === 'employee' || userDetails.isASM) &&
									<div>
										{(orderPlacedDetails.deliveryMethod === 'ADC LTL' || self.isAnyReplacementSelected(orderPlacedDetails))
											?<div>
												<p className="orange"><b>Thank you for Entering your return. The Return Request Details will be available to review under View Returns & Credits once a Return # has been assigned. This may take up to an hour. The Return Reference # below can be used to search for this return in View Returns & Credits.</b></p>
												<p className="orange">
													<b>
														{deliveryMethod === "I will return the products myself"
														 	? "Please print out the Return Authorization received via email and return the product to warehouse."
															: "The SDS or carrier will contact the customer within 3-5 days to schedule pickup of the return."
														}
													</b>
												</p>
											</div>
											:<div>
												<p className="orange"><b>Thank you for Booking your return. The Return Request Details will be available to review under View Returns & Credits once a Return # has been assigned. This may take up to an hour. The Return Reference # below can be used to search for this return in View Returns & Credits.</b></p>
												<p className="orange">
													<b>
														{deliveryMethod === "I will return the products myself"
														 	? "Please print out the Return Authorization received via email and return the product to warehouse."
															: "The SDS will contact the customer within 3-5 days to schedule pickup of the return."
														}
													</b>
												</p>
											</div>
										}
									</div>
								}
							</div>
						}
					</div>
					:<div className="push  d-none d-sm-block">
						<h1 className="pageTitle">Review Return Request</h1>
					</div>
				}
				{isOrderPlaced
					?<div className="push d-block d-sm-none m-3">
						<p className="textRight">
							<a className="withIcon withPrintIcon noUnderline bold uppercase" onClick={this.props.handlePrint} href="">Print Return Request Confirmation</a>
						</p>
						<h1 className="pageTitle">Return Request Confirmation</h1>
						{userDetails.typeOfUser === 'customer'
							?<div>
								<p className="orange"><b>Your return request has been submitted and is pending approval. You will be notified of the status of your request.<br />Any notes you may have included have been captured.</b></p>
								<p className="orange">
									<b>
										{deliveryMethod === "I will return the products myself"
											? "If your request is approved, please print out the Return Authorization received via email and return the product to warehouse."
											: "If your request is approved, you will be contacted by the SDS within 3-5 days to schedule pickup of the item(s) shown."
										}
									</b>
								</p>
							</div>
							:<div>
								{(userDetails.typeOfUser === 'employee' || userDetails.isASM) &&
									<div>
										{(orderPlacedDetails.deliveryMethod === 'ADC LTL' || self.isAnyReplacementSelected(orderPlacedDetails))
											?<div>
												<p className="orange"><b>Thank you for Entering your return. The Return Request Details will be available to review under View Returns & Credits once a Return # has been assigned. This may take up to an hour. The Return Reference # below can be used to search for this return in View Returns & Credits.</b></p>
												<p className="orange">
													<b>
														{deliveryMethod === "I will return the products myself"
														 	? "Please print out the Return Authorization received via email and return the product to warehouse."
															: "The SDS or carrier will contact the customer within 3-5 days to schedule pickup of the return."
														}
													</b>
												</p>
											</div>
											:<div>
												<p className="orange"><b>Thank you for Booking your return. The Return Request Details will be available to review under View Returns & Credits once a Return # has been assigned. This may take up to an hour. The Return Reference # below can be used to search for this return in View Returns & Credits.</b></p>
												<p className="orange">
													<b>
														{deliveryMethod === "I will return the products myself"
														 	? "Please print out the Return Authorization received via email and return the product to warehouse."
															: "The SDS will contact the customer within 3-5 days to schedule pickup of the return."
														}
													</b>
												</p>
											</div>
										}
									</div>
								}
							</div>
						}
					</div>
					:<div className="push d-block d-sm-none m-3">
						<h1 className="pageTitle">Review Return Request</h1>
					</div>
				}
				<div className="push  d-none d-sm-block">
					<p>
						{isOrderPlaced && <b>Return Reference #: {self.state.requestReturnOrderId}<br/></b>}
						<b>Account #:</b> {orderDetails.accountNumber}
					</p>
					<div className="columns reviewReturnColumns">
						<div className="column column3">
							<p>
								<b>{deliveryMethod === 'I will return the products myself' ? 'Return from' : 'Picking Up from'}:</b>
								{/* <b>Returned from:</b> */}
								<br />
								{shippingAddress && <span className="pickUpAddress">
									{shippingAddress.address1 && shippingAddress.address1.trim()}
									{shippingAddress.address1 && shippingAddress.address1.trim() !== ""?<br/>:null}
									{shippingAddress.city && shippingAddress.city.trim()}, {shippingAddress.state && shippingAddress.state.trim()} {shippingAddress.zip && shippingAddress.zip.trim()}<br />
									{orderDetails.phone}<br />
								</span>}
							</p>
						</div>
						<div className="column column4">
							<p>
								<b>{deliveryMethod === 'I will return the products myself' ? 'Return To' : 'Picking Up by'}:</b>
								{/* <b>Returned to:</b> */}
								<br />
								{returnToAddress && <span className="shippingAddress">
									{returnToAddress.name && returnToAddress.name.trim()}<br />
									{returnToAddress.address1 && returnToAddress.address1.trim()}
									{returnToAddress.address1 && returnToAddress.address1.trim() !== ""?<br/>:null}
									{returnToAddress.city && returnToAddress.city.trim()}, {returnToAddress.state && returnToAddress.state.trim()} {returnToAddress.zip && returnToAddress.zip.trim()}<br />
									{self.props.normalizePhoneNumber(returnToAddress.phone)}<br />
								</span>}
							</p>
						</div>
						{self.state.isOOP ? 
						<div className="column column5" style={{ border: '5px dotted red', padding: '10px' }}>
							<div style={{ display: 'flex', alignItems: 'center' }}>
								<input
									type="checkbox"
									checked={this.state.isOOPChecked}
									onChange={this.handleCheckboxChange.bind(this)}
								/>
								<p className="red" style={{ marginLeft: '1px' }}>
									This out of policy Return requires Region Manager approval.
								</p>
							</div>
							<p>By checking this box, I confirm that this has been approved and that I may be asked to provide an email from the approver upon audit.</p>
							<p className="bold">Please enter the name of approver here (Minimum 5 characters Required):</p>
							<input type="text" id="approverName" minLength ={5} placeholder='Approver Name' onChange = { this.handleApproverName.bind(this)} value={self.state.approverName}/>
						</div> : <div className="column column5"></div>}
					</div>
					<div className="columns reviewReturnColumns">
						<div className="column column1">
							<p>
								<b>Return Request Entered By:</b> {userDetails.firstName + " " + userDetails.lastName}<br />
								<b>Return Request Entered On:</b> {orderDetails.orderDate}<br />
							</p>
							<p>
								<b>PO:</b> {orderDetails.poNumber}<br />
								<b>Restocking PO:</b> {orderDetails.restockingPoNum}<br />
							</p>
						</div>
						<div className="column column2">
							<p>
								<b>
									{deliveryMethod === "I want products picked up"
										?'Pick Up Phone Number'
										:'Phone Number'
									}:
								</b> {orderDetails.deliveryPhone}<br />
								{deliveryMethod === "I want products picked up" &&
									<span><b>Pick Up Instructions:</b> {orderDetails.deliveryInstructions}<br /><br /></span>
								}
							</p>
							<p>
								<b>JOB:</b> {job[0].value !== "" ? job[0].value:""}<br />
								<b>LOT:</b> {lot[0].value !== "" ? lot[0].value:""}<br />
							</p>
						</div>
					</div>
				</div>
				
				<div className="push  d-block d-sm-none m-3">
					<p style={{fontSize:"10px"}}>
						{isOrderPlaced && <b>Return Reference #: {self.state.requestReturnOrderId}<br/></b>}
						<b style={{fontSize:"10px"}}>Account #:</b> {orderDetails.accountNumber}
					</p>
					<div className="reviewReturnColumns">
						<div>
							<p>
								<b>{deliveryMethod === 'I will return the products myself' ? 'Return from' : 'Picking Up from'}:</b>
								{/* <b>Returned from:</b> */}
								<br />
								{shippingAddress && <span className="pickUpAddress">
									{shippingAddress.address1 && shippingAddress.address1.trim()}
									{shippingAddress.address1 && shippingAddress.address1.trim() !== ""?<br/>:null}
									{shippingAddress.city && shippingAddress.city.trim()}, {shippingAddress.state && shippingAddress.state.trim()} {shippingAddress.zip && shippingAddress.zip.trim()}<br />
									{orderDetails.phone}<br />
								</span>}
							</p>
						</div>
						<div>
							<p>
								<b>{deliveryMethod === 'I will return the products myself' ? 'Return To' : 'Picking Up by'}:</b>
								{/* <b>Returned to:</b> */}
								<br />
								{returnToAddress && <span className="shippingAddress">
									{returnToAddress.name && returnToAddress.name.trim()}<br />
									{returnToAddress.address1 && returnToAddress.address1.trim()}
									{returnToAddress.address1 && returnToAddress.address1.trim() !== ""?<br/>:null}
									{returnToAddress.city && returnToAddress.city.trim()}, {returnToAddress.state && returnToAddress.state.trim()} {returnToAddress.zip && returnToAddress.zip.trim()}<br />
									{self.props.normalizePhoneNumber(returnToAddress.phone)}<br />
								</span>}
							</p>
						</div>
					</div>
					<div className="reviewReturnColumns">
						<div>
							<p>
								<b>JOB:</b> {job[0].value !== "" ? job[0].value:""}<br />
								<b>LOT:</b> {lot[0].value !== "" ? lot[0].value:""}<br />
							</p>
							<p>
								<b>PO:</b> {orderDetails.poNumber}<br />
								<b>Restocking PO:</b> {orderDetails.restockingPoNum}<br />
							</p>
							<p>
								<b>Return Request Entered By:</b> {userDetails.firstName + " " + userDetails.lastName}<br />
								<b>Return Request Entered On:</b> {orderDetails.orderDate}<br />
							</p>
						</div>
						<div>
							<p>
								<b>
									{deliveryMethod === "I want products picked up"
										?'Pick Up Phone Number'
										:'Phone Number'
									}:
								</b> {orderDetails.deliveryPhone}<br />
								{deliveryMethod === "I want products picked up" &&
									<span><b>Pick Up Instructions:</b> {orderDetails.deliveryInstructions}<br /><br /></span>
								}
							</p>

						</div>
					</div>
					{self.state.isOOP ? 
						<div style={{ border: '2px solid #FF000A', padding: '10px', backgroundColor:"#DDE8F1" }}>
							<div style={{ display: 'flex', alignItems: 'center' }}>
								<input
									type="checkbox"
									checked={this.state.isOOPChecked}
									onChange={this.handleCheckboxChange.bind(this)}
								/>
								<p className="red" style={{ marginLeft: '1px' }}>
									This out of policy Return requires Region Manager approval.
								</p>
							</div>
							<p>By checking this box, I confirm that this has been approved and that I may be asked to provide an email from the approver upon audit.</p>
							<p>Please enter the name of approver here (Minimum 5 characters Required):</p>
							<input type="text" id="approverName" style={{padding:"5px 5px"}} minLength ={5} placeholder='Approver Name' onChange = { this.handleApproverName.bind(this)} value={self.state.approverName}/>
						</div> : <div></div>}
				</div>
				<div className="push d-none d-sm-block">
					<h2>Original CSO (Order number): {orderDetails.originalOrderNumber}</h2>
					<table id="reviewReturnsTable" className="reviewReturnTable dataTableType2 noRowBorders" style={{borderBottom: '1px solid #555'}}>
						<thead>
							<tr className="viperDarkHeader">
								<th className="product">Product</th>
								<th className="quantityToReturn">Quantity<br />to Return</th>
								<th className="originalInvoiceNumber">Original<br />Invoice #</th>
								<th className="returnType">Return Type</th>
								<th className="reasonForReturn">Reason for Return Request</th>
								{shippingMethod !== 'ADC Truckload' && shippingMethod !== 'ADC Velocity' && <th className="replacementRequested">Replacement Requested</th>}
								<th className="restockingFee">Restocking fee</th>
								<th className="serialNumber">Serial Number</th>
								<th className="pictureUpload">Photo Upload <a className="questionMarkIcon" href="" onClick={this.handleDialog.bind(this, "RequestReturnUploadImageDialog", true)}><img src="../images/icon-question-mark.png" width={12} height={11} alt="What is this?" title="What is this?" /></a></th>
								{self.checkASMOrIsInDL() && userDetails.typeOfUser !== 'employee' && <th className="waive">
									{isOrderPlaced
										? "Waived"
										: <span>Waive?<br /><input type="checkbox" checked={self.state.selectAll} onChange={this.selectAllWaiveOff.bind(this)} /></span>
									}
								</th>}
							</tr>
						</thead>
						<tbody>
							{orderDetails.items && orderDetails.items.map((item, orderIndex) => {
								if(item.selected)
									return [<tr key={orderIndex}>
										<td className="product"><b>{item.internalItem}</b></td>
										<td className="quantityToReturn"><b>{item.returnQuantity}</b></td>
										<td className="originalInvoiceNumber"><b>{item.invoiceNumber}</b></td>
										<td className="returnType">{item.reasonCategory}</td>
										<td className="reasonForReturn"><b>{item.returnReason}</b></td>
										{shippingMethod !== 'ADC Truckload' && shippingMethod !== 'ADC Velocity' &&
											<td className="replacementRequested">
												{item.replacementNeeded ? "Yes" : "No"}
											</td>
										}
										<td className="restockingFee">
											{item.restockingFee ? self.props.formatMoney(item.restockingFee, 0, ".", ",", false, "$") : '$0.00'}
										</td>
										{self.checkASMOrIsInDL() && userDetails.typeOfUser !== 'employee' &&
											<td className="waive">
												{isOrderPlaced
													? (item.restockingFeeWaive ? "Yes" : "No")
													: <input type="checkbox" onChange={this.onChangeUpdateItems.bind(this, orderIndex)} name="restockingFeeWaive" checked={item.restockingFeeWaive} />
												}
											</td>
										}
										<td colSpan="2" className="serialNumber"> 
											<table style={{ width: '100%' }}>
												<tbody>
												{item.serialNumber.split(' ').map((serial, index) => (
													<tr key={index}>
													<td>{serial}</td>
													{(shippingMethod === 'SDS Delivery' || shippingMethod === "SDS Delivery Next Day" || shippingMethod ==='Meet Truck') && customerClassCodeElements.includes(customerClassCode)  ? null:
													item.returnReason.startsWith("Damaged") && serial && serial != "NA"  && <td style={{paddingLeft:"18%"}}>
														<label className='blueButton' style={{width:"70%", textTransform:"none"}}>
														{`Choose Photo(s)`}
														<div style={{display:"none"}}>
														<input accept="image/jpeg,image/pjpeg,image/gif,image/png,image/bmp,image/x-windows-bmp" type="file" 
														multiple placeholder='Upload Image' onChange={this.handleFileChange(item, serial, orderIndex)} />
														</div>
														</label>
														{item && item.fileUploadSerialErrors&& item.fileUploadSerialErrors.get(serial) !== 'File is uploaded successfully.'?<p className="red"><b>{item.fileUploadSerialErrors.get(serial)}</b></p>:null}
														{item && item.fileUploadSerialErrors && item.fileUploadSerialErrors.get(serial) === 'File is uploaded successfully.'
														?
														<div>
															<p className="bold">{item.fileUploadSerialErrors.get(serial)}</p>
															{item.serialAndUplodedFileList && item.serialAndUplodedFileList.get(serial) ? (
															<div>
																{item.serialAndUplodedFileList.get(serial).map((fileName, i) => (
																<p style={{ fontSize: '12px' }} key={i}>{fileName}</p>
																))}
															</div>
															) : null}
														</div>
														:null}
													</td>}
													</tr>
												))}
												</tbody>
											</table>
										</td>
									</tr>,
									item.relatedServices ? item.relatedServices.map((itm, ind) => {
										if(itm.type === "BAG") 
											return null;
										return <tr key={400 + ind}>
													<td className="productToReturn" style={{borderBottom: '0 none'}}>
															&nbsp; &nbsp; {itm.serviceId}
													</td>
													<td colSpan="5" className="quantityToReturn" style={{borderBottom: '0 none'}}>{item.returnQuantity}</td>
													<td>{itm.price ? self.props.formatMoney(itm.price, 0, ".", ",", false, "$") : '$0.00'}</td>																							
												</tr>
												}) : null,
									
								]
								return null;
							})}
							{/*
								,
								<tr key={200+index}>
									<td colSpan={6} style={{borderBottom: '1px solid #999', paddingTop: 0}}>
										{item.notes}
									</td>
								</tr>
							*/}
						</tbody>
					</table>
					
				</div>
				<div className="push  d-block d-sm-none m-3">
				<div className="captionAboveTable">
					<div className="columns ps-2">
							Original CSO (Order number): {orderDetails.originalOrderNumber}
						</div>
					</div>
						{orderDetails.items && orderDetails.items.map((item, orderIndex) => {
								if(item.selected)
									return [<div className="accordion accordion-borderless" id={`accordionRequestReturn3${orderIndex}`}  key={orderIndex}>
										<div>
											<h2 className="accordion-header" id={`flush-requestReturn3${orderIndex}`}>
											<button className="accordion-button mobileAccButton" type="button" data-bs-toggle="collapse" data-bs-target={`#flush-collapse3RR${orderIndex}`} aria-expanded="true" aria-controls={`flush-collapse3RR${orderIndex}`}>
														{`PRODUCT `} {item.internalItem}
													</button>
													</h2>
													<div id={`flush-collapse3RR${orderIndex}`} className={`accordion-collapse collapse show`} aria-labelledby={`flush-requestReturn3${orderIndex}`}>
															<table className='orderTable'>
																<tbody>
																	<tr className='border-bottom'>
																		<td className='p-3 fw-bold'>QUANTITY TO RETURN</td>
																		<td className="quantityToReturn"><b>{item.returnQuantity}</b></td>
																	</tr>
																	<tr className='border-bottom'>
																		<td className='p-3 fw-bold'>ORIGINAL INVOICE #</td>
																		<td className="originalInvoiceNumber"><b>{item.invoiceNumber}</b></td>
																	</tr>
																	<tr className='border-bottom'>
																		<td className='p-3 fw-bold'>RETURN TYPE</td>
																		<td className="returnType">{item.reasonCategory}</td>
																	</tr>
																	<tr className='border-bottom'>
																		<td className='p-3 fw-bold'>REASON FOR RETURN REQUEST</td>
																		<td className="reasonForReturn"><b>{item.returnReason}</b></td>
																	</tr>
																	<tr className='border-bottom'>
																		<td className='p-3 fw-bold'>REPLACEMENT NEDDED?</td>
																		{shippingMethod !== 'ADC Truckload' && shippingMethod !== 'ADC Velocity' &&
																			<td className="replacementRequested">
																				{item.replacementNeeded ? "Yes" : "No"}
																			</td>
																		}
																	</tr>
																	<tr className='border-bottom'>
																		<td className='p-3 fw-bold'>RESTOCKING FEE</td>
																		<td className="restockingFee">
																			{item.restockingFee ? self.props.formatMoney(item.restockingFee, 0, ".", ",", false, "$") : '$0.00'}
																			{self.checkASMOrIsInDL() && userDetails.typeOfUser !== 'employee' &&
																				<td className="waive">
																					{isOrderPlaced
																						? (item.restockingFeeWaive ? "Yes" : "No")
																						: <input type="checkbox" onChange={this.onChangeUpdateItems.bind(this, orderIndex)} name="restockingFeeWaive" checked={item.restockingFeeWaive} />
																					}
																			</td>
																			}
																		</td>
																	</tr>
																	<tr>
																		<td className='p-3 fw-bold' colSpan="2">SERIAL NUMBER(S)</td>
																	</tr>
																	{item.serialNumber.split(' ').map((serial, index) => (
																				<tr key={index}>
																					<td className='p-3'>{serial}</td>
																					{(shippingMethod === 'SDS Delivery' || shippingMethod === "SDS Delivery Next Day" || shippingMethod ==='Meet Truck') && customerClassCodeElements.includes(customerClassCode) ?null: 
																					item.returnReason.startsWith("Damaged") && serial && serial != "NA" && <td>
																						<label style={{width:"90%", textDecoration:"underline", color:"#0d6efd"}}>
																						{`Choose Photo(s)`}
																						<a className="questionMarkIcon" href="" onClick={this.handleDialog.bind(this, "RequestReturnUploadImageDialog", true)}><img src="../images/icon-question-mark.png" width={12} height={11} alt="What is this?" title="What is this?" /></a>
																						<div style={{display:"none"}}>
																						<input accept="image/jpeg,image/pjpeg,image/gif,image/png,image/bmp,image/x-windows-bmp" type="file" 
																						multiple placeholder='Upload Image' onChange={this.handleFileChange(item, serial, orderIndex)} />
																						</div>
																						</label>
																						{((item && item.fileUploadSerialErrors&& item.fileUploadSerialErrors.get(serial) !== 'File is uploaded successfully.' ) && this.state.showRequestReturnFileWarningDialog)
																						?<RequestReturnFileWarningDialog content ={item.fileUploadSerialErrors.get(serial)} handleDialog={this.handleDialog.bind(this)} showDialog={true}/>
																						:null}
																						{item && item.fileUploadSerialErrors && item.fileUploadSerialErrors.get(serial) === 'File is uploaded successfully.'
																						?
																						<div>
																							<p className="bold">{item.fileUploadSerialErrors.get(serial)}</p>
																							{item.serialAndUplodedFileList && item.serialAndUplodedFileList.get(serial) ? (
																							<div>
																								{item.serialAndUplodedFileList.get(serial).map((fileName, i) => (
																								<p style={{ fontSize: '12px' }} key={i}>{fileName}</p>
																								))}
																							</div>
																							) : null}
																						</div>
																						:null}
																					</td>}
																					</tr>
																		))}
																</tbody>
															</table>
													</div>
												</div>
										</div>,
										item.relatedServices ? item.relatedServices.map((itm, ind) => {
										if(itm.type === "BAG") 
											return null;
										return <div className="accordion accordion-borderless" id={`accordionRRSerial${ind}`}  key={ind}>
										<div>
											<h2 className="accordion-header" id={`flush-RRSerial${ind}`}>
											<button className="accordion-button mobileAccButton" type="button" data-bs-toggle="collapse" data-bs-target={`#flush-collapseOneRRSerial${ind}`} aria-expanded="true" aria-controls={`flush-collapseOneRRSerial${ind}`}>
												{`SERVICE `} {itm.serviceId}
															</button>
															</h2>
															<div id={`flush-collapseOneRRSerial${ind}`} className={`accordion-collapse collapse show`} aria-labelledby={`flush-RRSerial${ind}`}>
																	<table className='orderTable'>
																		<tbody>
																			<tr className='border-bottom'>
																				<td className='p-3 fw-bold'>QUANTITY</td>
																				<td className="quantityToReturn" style={{borderBottom: '0 none'}}>{item.returnQuantity}</td>
																			</tr>
																			<tr>
																				<td className='p-3 fw-bold'>PRICE</td>
																				<td>{itm.price ? self.props.formatMoney(itm.price, 0, ".", ",", false, "$") : '$0.00'}</td>																							
																			</tr>
																		</tbody>
																	</table>
															</div>
														</div>
											</div>
												}) : null,
								]
								return null;
							})}
				</div>
				{this.state.showOopErrorMessage ?
				<div className="push d-none d-sm-block" style={{ textAlign: 'right' }}>
				 <p className="bold red" style={{ marginTop: '1px' }}>Out of policy returns require RM approval. Please confirm approval above and enter the approver's name.</p>
				</div> : null}
				{this.state.showRequestReturnApprovalDialog ?
				<div className="push d-block d-sm-none" style={{ textAlign: 'right' }}>
				<RequestReturnApprovalDialog handleDialog={this.handleDialog.bind(this)} showDialog={true}/>
				</div> : null}
				{this.state.showSerialNumberuploadError ? <div className="push d-none d-sm-block" style={{ textAlign: 'right' }}>
				 <p className="bold red" style={{ marginTop: '1px' }}>Damaged returns require that a picture of the damage be uploaded before submittal. Please upload pictures before submitting.</p>
				</div> : null}
				{this.state.showRequestReturnWarningDialog ? <div className="push d-block d-sm-none" style={{ textAlign: 'right' }}>
				<RequestReturnWarningDialog handleDialog={this.handleDialog.bind(this)} showDialog={true}/>
				</div> : null}
				{!isOrderPlaced && <p className="textRight p-3">
					<a onClick={this.handleSubmitStep3.bind(this, job, lot, orderDetails.restockingPoNum, shippingMethod, customerClassCode)} style={{fontSize:"12px"}} className="blueButton p-2" href="">Submit Return Request</a>
				</p>}
				{this.state.showRequestReturnUploadImageDialog ?<RequestReturnUploadImageDialog handleDialog={this.handleDialog.bind(this)} showDialog={true}/>:null}
			</div>
        );
    }
}

const mapStateToProps = (state) => {
	return {
		order: state.order,
		user: state.user
	};
};

const mapDispatchToProps = (dispatch) => ({
	setRequestReturnDetails: (data) => dispatch(setRequestReturnDetails(data)),
	createNewOrder: (payload, params, useBootApi, response) => dispatch(createNewOrder(payload, params, useBootApi, response)),
	storeReturnUda: (payload, showLoader, callback) => dispatch(storeReturnUda(payload, showLoader, callback))
});

RequestReturnStep3 = connect(mapStateToProps, mapDispatchToProps)(RequestReturnStep3);
export default RequestReturnStep3;



// WEBPACK FOOTER //
// ./src/App/components/PostLogin/Order/requestReturnStep3.js